<style lang="less" scoped>
.dhxwList{position: relative;width: 100%;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;}
.mains{position: relative;width: 800px;display: flex;}
.first{display: flex;flex-direction: column;width: 780px;margin-right: 20px;margin-left: 353px;
    .vitrual{position: relative;margin-top: 20px;
    .photoTitle{position:absolute; top: 607px;left: 1px; width: 1180px;height: 20px; background-color: #1f1f1fc4;color:white;text-align: left;padding: 10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .prevVideo{position: absolute;top: 705px;left:6px;width: 20px;height: 34px;cursor: pointer;z-index: 99;}
    .nextVideo{position: absolute;top: 705px;left:1180px;width: 20px;height: 34px;cursor: pointer;z-index: 99;}
    .swiperVideo{position: relative;width:1200px;overflow: hidden;margin: 0;
        .container{width: 600px;margin: 0;}
        ul{list-style: none;display: flex;width: 2000px;padding: 0;margin-left: 1px;}
    }
    }
}
ul{list-style: none;margin: 0px;margin-left:-40px;margin-top: 0px;margin-bottom: 30px;;}
.imgTitleContent{text-align: left;}
.el-button{width: 800px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-bottom: 30px;}
</style>

<template>
  <div class="dhxwList">
    <Navigation v-if="this.catid !== ''" :navigationdatas="navigationList2"></Navigation>
    <Navigation v-else :navigationdatas="navigationList"></Navigation>
    <div class="mains">
      <div class="first">
        <div class="vitrual" style="position: relative;" @mouseover="mouseOver2()" @mouseleave="mouseLeave2()">
              <div class="video" @click="goPhotoList(photoid)">
                <img :src="photo" style="width: 1200px; height: 665px;cursor: pointer;" />
                <p class="photoTitle">{{ photoTitle }}</p>
              </div>
              <img v-if="isShow2" class="prevVideo" src="../../../../static/index/icon_slide_left.png" alt="" @click="prevVideo2">
              <img v-if="isShow2" class="nextVideo" src="../../../../static/index/icon_slide_right.png" alt="" @click="nextVideo2">
              <div class="swiperVideo">
                <div class="container" :style="{'margin-left': marginLeftP + 'px'}">
                  <ul>
                    <li v-for="(item,index) in photoList" :key="index">
                      <img :src="item" style="width: 141px;height: 94px;margin: 5px 4px;border-radius: 5px;cursor: pointer;" @click="getPIC(item)" />
                    </li>
                  </ul>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgTitleContent from '../assembly/ImgTitleContent'
import Navigation from '../assembly/Navigation'
export default {
  components: {
    ImgTitleContent,
    Navigation
  },

  name: '',
  data()
  {
    return {
      // ImgTitleContent组件数据
      imgTitleContentdata: [],
      currentPage: 1,
      navigationList: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '首页图片列表',
          path: '/SYphotoList'
        },
        {
          theme: '图片详情',
          path: ''
        }
      ],
      navigationList2: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '首页图片列表',
          path: '/SYphotoList'
        },
        {
          theme: '图片详情',
          path: ''
        }
      ],
      catid: '',
      sShow2: false,
      marginLeftP: 0,
      photo: [], // 首页图片大图
      photoTitle: '', // 首页图片标题
      photoid: '', // 首页图id
      photoList: [] // 首页图片数组
    }
  },
  
  created()
  {
  },
  watch: {
    $route: {
      handler(nval)
      {
        this.navigationList = []
        if (nval.query.id)
        {
          this.navigationList = [
            {
              theme: '首页',
              path: '/Kyforum'
            },
            {
              theme: '首页图片列表',
              path: '/SYphotoList'
            },
            {
              theme: '图片详情',
              path: ''
            }
          ]
          this.catid = nval.query.id
          this.currentPage = 1
          this.getList(nval.query.id)
          this.getPhotoList()
        }
        else
        {
          this.navigationList = [
            {
              theme: '首页',
              path: '/Kyforum'
            },
            {
              theme: '首页图片列表',
              path: '/SYphotoList'
            },
            {
              theme: '图片详情',
              path: ''
            }
          ]
          this.catid = ''
          this.currentPage = 1
          this.getNewsList2()
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    prevVideo2()
    {
      if (this.marginLeftP >= 0)
        return false
      this.marginLeftP += 149
    },
    nextVideo2()
    {
      if (this.marginLeftP <= -((this.photoList.length - 8) * 149))
        return false
      this.marginLeftP -= 149
    },
    mouseOver2()
    {
      this.isShow2 = true
    },
    mouseLeave2()
    {
      this.isShow2 = false
    },
    getList(val)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 112, _exp: 'id=?', types: 'i', vals: val, init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.photo = ret[0].data[0].thumb.split(',')[0]
        this.photoTitle = ret[0].data[0].title
        this.photoid = ret[0].data[0].id
        this.photoList = []
        console.log(ret)
        ret[0].data[0].thumb.split(',').forEach(item =>
        {
          this.photoList.push(item)
        })
      })
    },
    getPIC(item)
    {
      this.photo = item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/SYphotoDetails.vue